const CSSC = 'CROSS_STORAGE_SET_CLIENT';
const CSST = 'CROSS_STORAGE_SET_TOKEN';
const CSDT = 'CROSS_STORAGE_DELETE_TOKEN';
export { CSSC, CSST, CSDT };